'use es6';

import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import VizExLoadingButton from 'visitor-ui-component-library/button/VizExLoadingButton';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CIRRUS, EERIE } from 'HubStyleTokens/colors';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { ChatWidgetLocaleContextConsumer } from './ChatWidgetLocaleContext';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ConsentPrompt__Container",
  componentId: "upnej8-0"
})(["border-top:", ";display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;padding:12px 24px;position:relative;"], props => props.isOutsideChat ? '0' : `2px solid ${CIRRUS}`);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentPrompt__SmallNoParagraphPadding",
  componentId: "upnej8-1"
})(["display:block;word-break:break-word;word-wrap:break-word;-ms-word-break:break-all;p{margin-bottom:0;}margin-top:", ";"], props => props.isOutsideChat ? '16px' : `0`);
const FullWidthButton = styled(VizExButton).withConfig({
  displayName: "ConsentPrompt__FullWidthButton",
  componentId: "upnej8-2"
})(["flex:0 1 100%;"]);
const FlexWrapper = styled.div.withConfig({
  displayName: "ConsentPrompt__FlexWrapper",
  componentId: "upnej8-3"
})(["display:flex;flex-direction:row;width:100%;margin:12px 0 8px 0;"]);
const ConsentPrompt = ({
  message,
  onClick,
  onClose,
  showButton,
  isOneOfTargetedProductPages,
  isPortal53,
  isOutsideChat = false
}) => {
  const [submitting, setSubmitting] = useState(false);
  const onClickWrapper = () => {
    onClick();
    setSubmitting(true);
  };
  return /*#__PURE__*/_jsxs(Container, {
    "data-test-id": "gdpr-consent-prompt",
    dir: "auto",
    isOutsideChat: isOutsideChat,
    children: [!showButton && isPortal53 && isOneOfTargetedProductPages && /*#__PURE__*/_jsx(VizExCloseButton, {
      size: 'sm',
      onClick: onClose,
      theme: isOutsideChat ? createThemeV2({
        colors: {
          text: EERIE
        }
      }) : createThemeV2()
    }), /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
      use: "help",
      "data-test-id": "gdpr-consent-text",
      dangerouslySetInnerHTML: {
        __html: formatHtml(message)
      },
      isOutsideChat: isOutsideChat
    }), showButton && /*#__PURE__*/_jsx(FlexWrapper, {
      children: /*#__PURE__*/_jsx(VizExLoadingButton, {
        currentState: submitting ? 'submitting' : 'ready',
        Button: FullWidthButton,
        "data-test-id": "gdpr-consent-agree-button",
        onClick: onClickWrapper,
        children: /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
          children: locale => /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-experience-components.buttons.agree",
            options: {
              locale
            }
          })
        })
      })
    })]
  });
};
ConsentPrompt.propTypes = {
  isOneOfTargetedProductPages: PropTypes.bool.isRequired,
  isOutsideChat: PropTypes.bool,
  isPortal53: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showButton: PropTypes.bool.isRequired
};
ConsentPrompt.displayName = 'ConsentPrompt';
export default ConsentPrompt;